const constProd = require('./cnstnts.production');
const constStaging = require('./cnstnts.staging');
const constDev = require('./cnstnts.development');
const constLocal = require('./cnstnts.local');

try {
  if (process.env.REACT_APP_NODE_ENV === 'production') {
    module.exports = constProd;
  } else if (process.env.REACT_APP_NODE_ENV === 'development') {
    module.exports = constDev;
  } else if (process.env.REACT_APP_NODE_ENV === 'staging') {
    module.exports = constStaging;
  } else {
    module.exports = constLocal;
  }
} catch (err) {
  // eslint-disable-next-line no-console
  console.trace(err);
  module.exports = constLocal;
}
